// ** Logo
import logo from '@src/assets/images/logo/NTTS-r.png'

// Loaded at the app root (index.js), so these styles — including the
// reactstrap <Spinner /> override — apply everywhere
import '@src/assets/scss/ntts-tokens.css'
import './ntts-spinner.scss'

const SpinnerComponent = () => {
  return (
    <div className="ntts-app-loader" role="status" aria-live="polite">
      <img className="ntts-app-loader__logo" src={logo} alt="NTTS" />
      <span className="ntts-spinner ntts-spinner--lg" aria-hidden="true" />
      <span className="visually-hidden">Loading…</span>
    </div>
  )
}

export default SpinnerComponent
